module.exports = __webpack_public_path__ + "img/chat.464d2ff0.png";